import React, { FunctionComponent } from 'react';
import { cn } from '@/utils/cn';

type LoaderProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullHeight?: boolean;
  fullScreen?: boolean;
  className?: string;
  /** Custom loading text rendered in frost-mono kicker style below the disk. */
  text?: string;
  /** Hide the loading text entirely. */
  hideText?: boolean;
};

const SIZE_PX: Record<NonNullable<LoaderProps['size']>, number> = {
  sm: 20,
  md: 32,
  lg: 44,
  xl: 60
};

export const Loader: FunctionComponent<LoaderProps> = ({
  size = 'md',
  fullHeight = false,
  fullScreen = false,
  className = '',
  text,
  hideText = false
}) => {
  const dim = SIZE_PX[size];

  const containerClasses = cn(
    'flex flex-col items-center justify-center gap-3 agora-loader-enter',
    fullHeight && 'h-[60vh]',
    fullScreen &&
      'fixed inset-0 z-takeover bg-[rgba(var(--f-paper-rgb),0.78)] lg:backdrop-blur-[28px] lg:backdrop-saturate-[160%]',
    className
  );

  return (
    <div className={containerClasses}>
      <span
        className="frost-spinner"
        style={{ width: `${dim}px`, height: `${dim}px` }}
        role="status"
        aria-label={text || 'Cargando'}
      >
        <span className="frost-spinner__halo" />
        <span className="frost-spinner__aurora" />
      </span>

      {!hideText && text && (
        <p className="frost-mono text-fs-10-5 font-semibold tracking-[0.22em] uppercase text-frost-ink-whisper">
          {text}
        </p>
      )}

      <style>{`
        .agora-loader-enter {
          animation: agora-fade-in 0.25s ease-out both;
        }
        @keyframes agora-fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};
